<nz-modal [(nzVisible)]="visible" [nzTitle]="title()" [nzWidth]="width()" [nzClosable]="closable()"
  [nzMaskClosable]="maskClosable()" [nzFooter]="showDefaultFooter() ? defaultFooter : null"
  (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <ng-content></ng-content>
  </ng-container>
</nz-modal>

<ng-template #defaultFooter>
  <button nz-button (click)="handleCancel()">{{ cancelText() }}</button>
  <button nz-button nzType="primary" [nzLoading]="confirmLoading()" [disabled]="okDisabled()" (click)="handleOk()">
    {{ okText() }}
  </button>
</ng-template>
